import { Link } from "react-router-dom";
import { Search, Send, Handshake, ShieldCheck } from "lucide-react";

const STEPS = [
  { icon: Search, title: "Cherchez", text: "Choisissez la ville, les dates et le nombre de voyageurs, puis comparez photos, prix et équipements." },
  { icon: Send, title: "Envoyez une demande", text: "Gratuit et sans engagement, même sans compte. Le propriétaire accepte ou refuse et vous êtes prévenu par courriel." },
  { icon: Handshake, title: "Réglez avec le propriétaire", text: "Une fois acceptée, vous recevez l'adresse et son contact. Le paiement du séjour se fait directement avec lui." },
];

export const ResidenceHowItWorks = () => (
  <section data-testid="section-residences-how" className="mt-6 sm:mt-8 rounded-3xl bg-white border border-[#EFE6DB] p-5 sm:p-8">
    <span className="text-[11px] font-bold uppercase tracking-widest text-[#FF5A4F]">Résidences meublées</span>
    <h2 className="font-display text-xl sm:text-3xl font-extrabold text-[#123B4A]">Comment ça marche ?</h2>
    <ol className="grid sm:grid-cols-3 gap-4 sm:gap-6 mt-5">
      {STEPS.map((s, i) => (
        <li key={s.title} data-testid={`res-how-step-${i + 1}`} className="relative rounded-2xl bg-[#FFF8F1] p-4 sm:p-5">
          <span className="absolute top-3 right-4 font-display text-3xl font-black text-[#FF5A4F]/15">{i + 1}</span>
          <div className="w-10 h-10 rounded-xl bg-[#FF5A4F] text-white grid place-items-center"><s.icon className="w-5 h-5" /></div>
          <h3 className="font-bold text-[#123B4A] mt-3">{s.title}</h3>
          <p className="text-sm text-[#5B6B73] mt-1 leading-relaxed">{s.text}</p>
        </li>
      ))}
    </ol>
    <div className="mt-5 flex flex-col sm:flex-row sm:items-center gap-3 justify-between">
      <p data-testid="res-how-free-note" className="flex items-start gap-2 text-sm text-[#123B4A]"><ShieldCheck className="w-4 h-4 mt-0.5 text-emerald-600 shrink-0" />La réservation sur Babimix est gratuite : aucun paiement en ligne, aucune commission.</p>
      <Link to="/residences" data-testid="res-how-cta" className="shrink-0 text-center rounded-full bg-[#123B4A] text-white text-sm font-bold px-5 py-2.5">Voir les résidences</Link>
    </div>
  </section>
);
